import { __assign } from "tslib";
import { connect } from 'react-redux';
import { getIsLoggedIn, getWatchCount, getCartCount, getFeedbackCount, getNotesCount, getIsEclipseSwitcherEnabled, getVerificationEmailAddress, getCoreLevel, getCurrentUserHasWixPortfolio, getCanUserSeeWatch, getCurrentUserHasCore, } from '../publicSession/selectors';
import { getChatUnreadCount } from '../Chat/redux/selectors';
import { siteHeaderSearchButtonClicked, userLogoutButtonClicked, openUserDropdown, closeUserDropdown, openNotificationsDropdown, closeNotificationsDropdown, toggleSubmitMenu, openSearchModal, closeSearchModal, toggleSearchModal, hidePortfolioTooltip, deletePortfolio, } from './redux/actions';
import { switchVersion } from '../publicSession/actions';
import { getSiteHeaderState } from './redux/selectors';
import { pushModal } from '../Modals/redux/basicActions';
import { ModalType } from '../Modals/redux/types';
function mapStateToProps(state) {
    return __assign({ isLoggedIn: getIsLoggedIn(state), watchCount: getWatchCount(state), cartCount: getCartCount(state), chatCount: getChatUnreadCount(state), feedbackCount: getFeedbackCount(state), noteCount: getNotesCount(state), disableVersionSwitcher: !getIsEclipseSwitcherEnabled(state), hasWixPortfolio: !getCurrentUserHasWixPortfolio(state), verificationEmail: getVerificationEmailAddress(state), canSeeOldWatch: getCanUserSeeWatch(state), coreLevel: getCoreLevel(state), hasCoreMembership: getCurrentUserHasCore(state) }, getSiteHeaderState(state));
}
var mapDispatchToProps = {
    onSiteHeaderSearchButtonClicked: siteHeaderSearchButtonClicked,
    onUserLogoutButtonClicked: userLogoutButtonClicked,
    switchVersion: switchVersion,
    openUserDropdown: openUserDropdown,
    closeUserDropdown: closeUserDropdown,
    openNotificationsDropdown: openNotificationsDropdown,
    closeNotificationsDropdown: closeNotificationsDropdown,
    toggleSubmitMenu: toggleSubmitMenu,
    openSearchModal: openSearchModal,
    closeSearchModal: closeSearchModal,
    toggleSearchModal: toggleSearchModal,
    hidePortfolioTooltip: hidePortfolioTooltip,
    deletePortfolio: deletePortfolio,
    pushChatModal: function () {
        return pushModal(ModalType.MOBILE_CHAT_LIST, { wrapInModal: false });
    },
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SiteHeader.container.js.map